<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame" clip-path="url(#clip0_4487_3290)">
      <path
        id="Vector"
        d="M13.333 17.3333C13.333 18.0405 13.614 18.7188 14.1141 19.2189C14.6142 19.719 15.2924 20 15.9997 20C16.7069 20 17.3852 19.719 17.8853 19.2189C18.3854 18.7188 18.6663 18.0405 18.6663 17.3333C18.6663 16.626 18.3854 15.9478 17.8853 15.4477C17.3852 14.9476 16.7069 14.6666 15.9997 14.6666C15.2924 14.6666 14.6142 14.9476 14.1141 15.4477C13.614 15.9478 13.333 16.626 13.333 17.3333Z"
        stroke="#F1D4B5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_2"
        d="M10.667 28V26.6667C10.667 25.9594 10.9479 25.2811 11.448 24.781C11.9481 24.281 12.6264 24 13.3337 24H18.667C19.3742 24 20.0525 24.281 20.5526 24.781C21.0527 25.2811 21.3337 25.9594 21.3337 26.6667V28"
        stroke="#F1D4B5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_3"
        d="M20 6.66667C20 7.37391 20.281 8.05219 20.781 8.55229C21.2811 9.05238 21.9594 9.33333 22.6667 9.33333C23.3739 9.33333 24.0522 9.05238 24.5523 8.55229C25.0524 8.05219 25.3333 7.37391 25.3333 6.66667C25.3333 5.95942 25.0524 5.28115 24.5523 4.78105C24.0522 4.28095 23.3739 4 22.6667 4C21.9594 4 21.2811 4.28095 20.781 4.78105C20.281 5.28115 20 5.95942 20 6.66667Z"
        stroke="#F1D4B5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_4"
        d="M22.667 13.3334H25.3337C26.0409 13.3334 26.7192 13.6143 27.2193 14.1144C27.7194 14.6145 28.0003 15.2928 28.0003 16V17.3334"
        stroke="#F1D4B5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_5"
        d="M6.66699 6.66667C6.66699 7.37391 6.94794 8.05219 7.44804 8.55229C7.94814 9.05238 8.62641 9.33333 9.33366 9.33333C10.0409 9.33333 10.7192 9.05238 11.2193 8.55229C11.7194 8.05219 12.0003 7.37391 12.0003 6.66667C12.0003 5.95942 11.7194 5.28115 11.2193 4.78105C10.7192 4.28095 10.0409 4 9.33366 4C8.62641 4 7.94814 4.28095 7.44804 4.78105C6.94794 5.28115 6.66699 5.95942 6.66699 6.66667Z"
        stroke="#F1D4B5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector_6"
        d="M4 17.3334V16C4 15.2928 4.28095 14.6145 4.78105 14.1144C5.28115 13.6143 5.95942 13.3334 6.66667 13.3334H9.33333"
        stroke="#F1D4B5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4487_3290">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
